import { Component } from "@angular/core";
import { MdDialog, MdDialogRef, MdSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { AdalService } from "../../shared/adal.service";
import { LicenseService } from "../../services/LicenseService";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { GenerateGIS360LicenseComponent } from "./popup/generate-gis360-license/generate-gis360-license.component";
import { GIS360FilterPipe } from "./pipes/gis360FilterPipe";
import { RenewGIS360LicenseComponent } from "./popup/renew-gis360-license/renew-gis360-license.component";
import { ViewGIS360RenewalHistoryComponent } from "./popup/view-gis360-renewal-history/view-gis360-renewal-history.component";
import { ViewGIS360ActivationDetailsComponent } from "./popup/view-gis360-activation-details/view-gis360-activation-details.component";
import { ViewGIS360LicenseInformationComponent } from "./popup/view-gis360-license-information/view-gis360-license-information.component";
import { ActivateGIS360LicenseComponent } from "./popup/activate-gis360-license/activate-gis360-license.component";

@Component({
  selector: "license-gis360",
  template: require('./gis360.component.html'),
  styles: [require('./gis360.component.css')],
})
export class LicenseModuleGIS360Component {
  ProductId;
  IsAddEdit;
  IsDelete;
  errorMessage = "";

  originalGIS360LicenseList = [];
  filteredGIS360LicenseList = [];
  pager: any = {};
  pagedItems = [];

  expandedRow = null;
  isLoading = false;
  licenseKeyDetails = [];

  // Search: Sales Order No contains (ignores case), Customer Name exact match (case sensitive), License Key exact match (ignores case)
  searchSalesOrderNo = "";
  searchCustomerName = "";
  searchLicenseKey = "";
  filterSalesOrderNo = "";
  filterCustomerName = "";
  filterLicenseKey = "";
  customerNames: string[] = [];

  constructor(
    private dialog: MdDialog,
    private appLoader: AppLoaderService,
    private adalService: AdalService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private licenseService: LicenseService,
    private pagerService: PagerService,
    private snackBar: MdSnackBar,
    private filterPipe: GIS360FilterPipe,
  ) {
    if (!this.adalService.getCachedToken()) {
      setTimeout(() => {
        this.router.navigate(["login"]);
      }, 100);
    }

    route.params.subscribe((params) => {
      this.ProductId = params["productId"];
      this.getUserRights();
    });
    this.appLoader.open();
    this.getGIS360LicenseList();
  }

  getUserRights() {
    let UserId = Number(localStorage.getItem("userid"));
    this.userService
      .getUserLicenseRightById(UserId, this.ProductId)
      .subscribe((data) => {
        if (!data.IsError && data.DataObject != null) {
          this.IsAddEdit = data.DataObject.IsAddEdit;
          this.IsDelete = data.DataObject.IsDelete;
        }
      });
  }

  getGIS360LicenseList() {
    this.licenseService.getGIS360LicenseList().subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.setLicenseList(data.DataObject);
        } else {
          this.originalGIS360LicenseList = [];
          this.errorMessage = data.Error;
          this.expandedRow = null;
          this.setCustomerNames();
          this.setPage(1);
        }
        this.appLoader.close();
      },
      (err) => {
        this.appLoader.close();
      },
    );
  }

  // Shows a license list: from GetGIS360LicenseList, or the LicenseList returned by a save API (Generate, Edit, Renew, Delete)
  setLicenseList(licenseList) {
    this.originalGIS360LicenseList = licenseList;
    this.errorMessage = "";
    this.expandedRow = null;
    this.setCustomerNames();
    this.setPage(1);
  }

  // Distinct customer names for the dropdown; case sensitive, so "Acme" and "ACME" are listed separately
  setCustomerNames() {
    const names = this.originalGIS360LicenseList
      .map((element) => element.CustomerName)
      .filter((name) => name != null && name !== "");
    this.customerNames = names.filter((name, index) => names.indexOf(name) === index).sort();
    if (this.searchCustomerName && this.customerNames.indexOf(this.searchCustomerName) === -1) {
      this.searchCustomerName = this.filterCustomerName = "";
    }
  }

  search() {
    this.filterSalesOrderNo = this.searchSalesOrderNo;
    this.filterCustomerName = this.searchCustomerName;
    this.filterLicenseKey = this.searchLicenseKey;
    this.setPage(1);
  }

  clearSearch() {
    this.searchSalesOrderNo = this.filterSalesOrderNo = "";
    this.searchCustomerName = this.filterCustomerName = "";
    this.searchLicenseKey = this.filterLicenseKey = "";
    this.setPage(1);
  }

  setPage(page: number) {
    this.filteredGIS360LicenseList = this.filterPipe.transform(
      this.originalGIS360LicenseList,
      this.filterSalesOrderNo,
      this.filterCustomerName,
      this.filterLicenseKey,
    );
    this.pager = this.pagerService.getPager(this.filteredGIS360LicenseList.length, page);
    this.pagedItems = this.filteredGIS360LicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.expandedRow = null;
    if (this.pagedItems.length == 0 && (!this.errorMessage || this.errorMessage == "No records found.")) {
      this.errorMessage = "No records found.";
    } else if (this.pagedItems.length > 0 && this.errorMessage == "No records found.") {
      this.errorMessage = "";
    }
  }

  expandRow(index, row) {
    this.expandedRow = this.expandedRow === index ? null : index;
    if (this.expandedRow != null) {
      this.isLoading = true;
      this.licenseKeyDetails = [];
      this.licenseService.getGIS360LicenseKeys(row.LicenseMasterId).subscribe(
        (data) => {
          if (!data.IsError && data.DataObject != null) {
            this.licenseKeyDetails = data.DataObject;
          }
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
        },
      );
    }
  }

  openGenerateNewLicenseDialog() {
    let generateLicenseDialogRef: MdDialogRef<GenerateGIS360LicenseComponent> =
      this.dialog.open(GenerateGIS360LicenseComponent, {
        width: "60%",
        data: {
          GIS360LicenseData: this.originalGIS360LicenseList,
          dialogTitle: "Generate New License",
        },
        disableClose: true,
      });
    generateLicenseDialogRef.afterClosed().subscribe((result) => {
      if (result && result.LicenseList) {
        this.setLicenseList(result.LicenseList);
      }
    });
  }

  // Edit is shown only while no License Key of the sales order is activated
  openEditLicenseDialog(row) {
    let editLicenseDialogRef: MdDialogRef<GenerateGIS360LicenseComponent> =
      this.dialog.open(GenerateGIS360LicenseComponent, {
        width: "60%",
        data: {
          GIS360LicenseData: this.originalGIS360LicenseList,
          SelectedLicense: row,
          dialogTitle: "Edit License",
        },
        disableClose: true,
      });
    editLicenseDialogRef.afterClosed().subscribe((result) => {
      if (result && result.LicenseList) {
        this.setLicenseList(result.LicenseList);
      }
    });
  }

  // Renew is always available [also before activation]; any License Keys of the sales order can be renewed
  openRenewLicenseDialog(row) {
    let renewLicenseDialogRef: MdDialogRef<RenewGIS360LicenseComponent> =
      this.dialog.open(RenewGIS360LicenseComponent, {
        width: "60%",
        data: {
          GIS360LicenseData: this.originalGIS360LicenseList,
          SelectedLicense: row,
          dialogTitle: "Renew License",
        },
        disableClose: true,
      });
    renewLicenseDialogRef.afterClosed().subscribe((result) => {
      if (result && result.LicenseList) {
        this.setLicenseList(result.LicenseList);
      }
    });
  }

  // Opened from a License Key's Expiry Date in the expanded panel: renewal history of that License Key only
  // Read-only view of the license and its License Keys [same as SCAL's View license information]
  openLicenseInformationDialog(row) {
    this.dialog.open(ViewGIS360LicenseInformationComponent, {
      width: "60%",
      data: {
        SelectedRow: row,
        dialogTitle: "GIS360 License Information",
      },
      disableClose: true,
    });
  }

  // subRow = License Key row of the expanded panel
  openRenewalHistoryDialog(subRow) {
    this.dialog.open(ViewGIS360RenewalHistoryComponent, {
      width: "60%",
      data: {
        SelectedSubRow: subRow,
        dialogTitle: "Renewal History",
      },
      disableClose: true,
    });
  }

  // subRow = License Key row of the expanded panel; Deactivate in the popup needs the Delete permission
  openActivationDetailsDialog(subRow) {
    let activationDetailsDialogRef: MdDialogRef<ViewGIS360ActivationDetailsComponent> =
      this.dialog.open(ViewGIS360ActivationDetailsComponent, {
        width: "70%",
        data: {
          SelectedSubRow: subRow,
          dialogTitle: "Activation Details",
          IsDelete: this.IsDelete,
        },
        disableClose: true,
      });
    activationDetailsDialogRef.afterClosed().subscribe((result) => {
      if (result && result.LicenseList) {
        this.setLicenseList(result.LicenseList);
      }
    });
  }

  // Activate one License Key of the sales order on a device; returns the signed activation key (same flow as SCAL)
  activateLicense(row) {
    let activateLicenseDialogRef: MdDialogRef<ActivateGIS360LicenseComponent> =
      this.dialog.open(ActivateGIS360LicenseComponent, {
        width: "60%",
        data: {
          SelectedRow: row,
          dialogTitle: "Activate License",
        },
        disableClose: true,
      });
    activateLicenseDialogRef.afterClosed().subscribe((result) => {
      if (result && result.LicenseList) {
        this.setLicenseList(result.LicenseList);
      }
    });
  }

  // Delete is shown only while no License Key of the sales order is activated; deletes the license and all its License Keys
  deleteLicense(row) {
    Swal.fire({
      title: "Delete License",
      text:
        "Are you sure you want to delete the license of sales order " +
        row.SalesOrderNo +
        "? All its " +
        row.NoOfLicenses +
        " license key(s) will be deleted.",
      showCancelButton: true,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonColor: "#FFCA28",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        const model = {
          LicenseMasterId: row.LicenseMasterId,
          UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.appLoader.open();
        this.licenseService.DeleteGIS360License(model).subscribe(
          (data) => {
            if (!data.IsError && data.DataObject != null) {
              this.snackBar.open("License deleted successfully", "", { duration: 3000 });
              this.setLicenseList(data.DataObject.LicenseList);
              this.appLoader.close();
            } else {
              this.appLoader.close();
              this.snackBar.open(data.Error, "", { duration: 3000 });
            }
          },
          (err) => {
            this.appLoader.close();
            this.snackBar.open("Something went wrong.", "", { duration: 3000 });
          },
        );
      }
    });
  }

  // row = sales order row of the main grid, subRow = License Key row of the expanded panel
  // Last License Key of the sales order: the whole license is deleted [same as SCAL]
  deleteLicenseKey(row, subRow) {
    const isLastLicenseKey = this.licenseKeyDetails.length <= 1;
    Swal.fire({
      title: isLastLicenseKey ? "Delete License" : "Delete License Key",
      text: isLastLicenseKey
        ? "This is the last license key of sales order " + row.SalesOrderNo + ". Deleting it will delete the whole license. Are you sure?"
        : "Are you sure you want to delete license key " + subRow.LicenseKey + "?",
      showCancelButton: true,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonColor: "#FFCA28",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        const model = {
          LicenseKeyId: subRow.LicenseKeyId,
          UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.appLoader.open();
        this.licenseService.DeleteGIS360LicenseKey(model).subscribe(
          (data) => {
            if (!data.IsError && data.DataObject != null) {
              this.snackBar.open(
                data.DataObject.IsLicenseDeleted ? "License deleted successfully" : "License key deleted successfully",
                "",
                { duration: 3000 },
              );
              this.setLicenseList(data.DataObject.LicenseList);
              this.appLoader.close();
            } else {
              this.appLoader.close();
              this.snackBar.open(data.Error, "", { duration: 3000 });
            }
          },
          (err) => {
            this.appLoader.close();
            this.snackBar.open("Something went wrong.", "", { duration: 3000 });
          },
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/gis360/gis360.component.ts